import React from 'react';
import { Helmet } from 'react-helmet';

function Seo({ lang = 'en' }) {
  const title = lang === 'en' ? 'Ephod: Strategy Card Game' : '에포드: 전략형 카드 게임';
  const description =
    lang === 'en'
      ? 'Ephod is a strategy card game that supports both Android and iOS.'
      : '에포드는 Android, iOS에서 플레이할 수 있는 전략형 카드 게임입니다.';

  return (
    <Helmet
      htmlAttributes={{ lang }}
      title={title}
      defaultTitle={title}
      meta={[
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:site_title`,
          content: title,
        },
        {
          name: `description`,
          content: description,
        },
        {
          property: `og:description`,
          content: description,
        },
        {
          property: 'og:author',
          content: 'zoomkoding',
        },
        {
          property: 'og:image',
          content: '/og-image.png',
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `google-site-verification`,
          content: `LutwK68TugbNvPt-uuIerdXD_fIjInEmmDIYK6Sm9Yo`,
        },
      ]}
    />
  );
}

export default Seo;
